/**
 * @generated SignedSource<<d6ab8b8d0d9108ddae7dbc62ecdae5e7>>
 * @relayHash b9e4f110bfe6e9bf16905087f91cd783
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3cad6e62bea4311358af95cb6d0c777a4db35dcc2c32644f404f148fb7b95309

var node = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "helpCenterAri"
    },
    v3 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    },
    v4 = {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    },
    v5 = {
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "helpCenterAri"
    },
    v6 = {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    },
    v7 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "id"
      }, {
        "kind": "ScalarField",
        "name": "title"
      }, {
        "kind": "ScalarField",
        "name": "contentType"
      }, {
        "concreteType": "HelpObjectStoreArticleURLInfo",
        "kind": "LinkedField",
        "name": "urlInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "name": "viewUrl"
        }]
      }],
      "type": "HelpObjectStoreSupportSiteArticleSearchResult"
    },
    v8 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "message"
      }],
      "type": "QueryError"
    },
    v9 = {
      "kind": "ScalarField",
      "name": "__typename"
    },
    v10 = {
      "kind": "ScalarField",
      "name": "cursor"
    },
    v11 = {
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "name": "endCursor"
      }, {
        "kind": "ScalarField",
        "name": "hasNextPage"
      }]
    },
    v12 = [v4 /*: any*/, {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    }, v5 /*: any*/, v6 /*: any*/];
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/],
      "kind": "Fragment",
      "name": "articleSearchComponentQuery",
      "selections": [{
        "alias": "helpObjectStore_searchArticlesForSupportSite",
        "args": [v4 /*: any*/, v5 /*: any*/, v6 /*: any*/],
        "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
        "kind": "LinkedField",
        "name": "__ArticleSearchComponent__helpObjectStore_searchArticlesForSupportSite_connection",
        "plural": false,
        "selections": [{
          "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [v7 /*: any*/, v8 /*: any*/, v9 /*: any*/]
          }, v10 /*: any*/]
        }, v11 /*: any*/]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v0 /*: any*/, v2 /*: any*/, v3 /*: any*/, v1 /*: any*/],
      "kind": "Operation",
      "name": "articleSearchComponentQuery",
      "selections": [{
        "args": v12 /*: any*/,
        "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticlesForSupportSite",
        "plural": false,
        "selections": [{
          "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [v9 /*: any*/, v7 /*: any*/, v8 /*: any*/]
          }, v10 /*: any*/]
        }, v11 /*: any*/]
      }, {
        "args": v12 /*: any*/,
        "filters": ["cloudId", "helpCenterAri", "input"],
        "handle": "connection",
        "key": "ArticleSearchComponent__helpObjectStore_searchArticlesForSupportSite",
        "kind": "LinkedHandle",
        "name": "helpObjectStore_searchArticlesForSupportSite"
      }]
    },
    "params": {
      "id": "3cad6e62bea4311358af95cb6d0c777a4db35dcc2c32644f404f148fb7b95309",
      "metadata": {
        "connection": [{
          "count": "first",
          "cursor": null,
          "direction": "forward",
          "path": ["helpObjectStore_searchArticlesForSupportSite"]
        }]
      },
      "name": "articleSearchComponentQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "4d8b2a7ae88235816fa16c6f68285e36";
export default node;